


































































































































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/MCQ.scss";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import Questions from "../components/Questions.vue";
import * as franc from "franc";
import moment from 'moment';
import VueApexCharts from "vue-apexcharts";

@Component({
  components: {
    apexchart: VueApexCharts,
    question: Questions,
  },
})
export default class CustomExam extends Vue {
  private service = new GeneralService();
  private items: GActivity[] = [];
  private questions: QuestionE[] = [];
  private questionComponentKey = 0;
  private answers: ProvidedAnswers[] = [];
  private sheetAnswerData: any = [];
  private isQuestion = false;
  private attempted: number = 0;
  private topicId: string = "";
  private level_id;
  private checkTopic = false;
  private auth = new AuthService();
  private mcqlimit = 10000;
  private chapterlimit = 10000;
  private topiclimit = 10000;
  private modalShow = false;
  private emptyAnswers: any = [];
  private isPastPaper = false;
  private chapterIds: any = [];
  private checkedChapters: any = [];
  private allChapters: any = [];
  private limitQuestions = 1;
  private shouldDisplay = false;
  private startTime:any = moment();
  private endTime:any = moment();
  private timeTaken:any = -1;
  private secondsTaken: any = 0;
  private shouldDisable = false;
  private correctAnswers = 0;
  private incorrectAnswers = 0;
  private isFinished = false;
  private series:any = []
  private isReview = false;
  private isLoading = false;


  private options = {
    labels: ['Correct', 'Incorrect', 'Unattempted'],
    colors:['#218f2c', '#b82121', '#e0ed28'],
    legend: {
      show: false,
    },
  };

  private finishTest(){
    this.isFinished = true;
    this.endTime = moment();

    this.timeTaken = this.endTime.diff(this.startTime, 'minutes', true);

    if (this.timeTaken > 0){
      this.secondsTaken = Math.floor((this.timeTaken % 1) * 60)
      this.timeTaken = Math.floor(this.timeTaken)
    }

    this.series = [this.correctAnswers, this.incorrectAnswers, this.questions.length - this.correctAnswers - this.incorrectAnswers]
  }

  private reviewTest(){
    this.shouldDisplay = true;
    this.isReview = !this.isReview;
  }

  private checkLang(str) {
    var lst = ["und", "urd", "fas", "pes", "skr", "arb", "uig"];
    var lan = franc(str, { minLength: 3 });

    return lst.indexOf(lan) > -1;
  }

  stripHtml(html: string): string {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  private addChapter(items) {
    this.chapterIds = [];
    for (let i = 0; i < items.length; i++) {
      this.chapterIds.push(items[i]);
    }

    for (let i = 0; i < this.allChapters.length; i++) {
      if (this.chapterIds.includes(this.allChapters[i]))
        Vue.set(this.checkedChapters, i, "checked");

      else Vue.set(this.checkedChapters, i, "not_checked");
    }
  }

  private selectAll(){
    this.chapterIds = []
    for (let i = 0; i < this.allChapters.length; i++) {
        Vue.set(this.checkedChapters, i, "checked");
        this.chapterIds.push(this.allChapters[i])
    }
  }

  private deselectAll(){
    this.chapterIds = []
    for (let i = 0; i < this.allChapters.length; i++) 
      Vue.set(this.checkedChapters, i, "not_checked");    
  }

  answerAttempt(response) {
    if (this.answers !== undefined && response !== undefined) {
      let trueAns = this.answers.find(
        (e) => e.questionId === response.questionId
      );

      if (trueAns !== undefined) {
        trueAns.answer = true;
        trueAns.answerId = response.answerId;
      }

      if (response.styles == 'alert-success')
        this.correctAnswers++;
      else 
        this.incorrectAnswers++;

      let questionType = this.questions.find(
        (e) => e.qid === response.questionId
      );

      if (questionType !== undefined) {
        questionType.questiontype =
          response.styles == undefined ? 1 : response.styles == "red" ? 3 : 2;
      }

      this.attempted = this.answers.filter((e) => e.answer === true).length;
    }
  }

  private saveMCQ() {
    this.saveWatched();
    if (this.sheetAnswerData.length < 1)
      this.service
        .insertSheetAnswers(config.createGuid(), this.topicId, this.answers)
        .then((response) => {
          window.location.reload();
        })
        .catch((err) => {
          window.location.reload();
        });
    else
      this.service
        .updateSheetAnswers(
          this.sheetAnswerData.userMcqResponseId,
          this.topicId,
          this.answers
        )
        .then((response) => {
          window.location.reload();
        })
        .catch((err) => {
          window.location.reload();
        });
  }

  private getTopics(id) {
    if (this.checkTopic) {
      // this.service.questions(id + ':1')
      //     .then(result => { this.questions = result; console.log(this.questions) })
      //     .catch(err => { console.error(`Error: ${err.message}`); });
    } else {
      this.checkTopic = true;
      this.topicId = id;
      this.service
        .topics(id)
        .then((result) => {
          this.items = result;
        })
        .catch((err) => {
          console.error(`Error: ${err.message}`);
        });
    }
  }

  private async getQuestions() {
    window.scrollTo(0, 0);
    if (this.chapterIds.length < 1){
      alert('Please select atleast one chapter first.');
      return;
    }
    this.isLoading = true;
    this.isQuestion = true;
    let queryString = this.chapterIds[0];

    if (this.chapterIds.length > 1) {
      for (let i = 1; i < this.chapterIds.length; i++) {
        queryString += "," + this.chapterIds[i];
      }
    }

    this.questions = [];

    await this.service
      .getQuestionsWAnswersB(this.limitQuestions, this.chapterIds)
      .then((result) => {
        this.answers = [];
        this.isLoading = false;
        this.emptyAnswers = [];
        if (result && result.length > 0) {
          for (let quest of result) {
            this.answers.push({
              questionId: quest.qid,
              answer: false,
              answerId: "",
            });
            try {
              quest.fullquestion = config.renderHTML(quest.fullquestion);
            } catch {
              result.splice(result.findIndex((e) => e.fullquestion == quest.fullquestion), 1);
            }
          }
          this.startTime = moment();
          this.questions = result.splice(0, Math.min(result.length, this.mcqlimit));
          this.emptyAnswers = this.answers;
        } else {
          this.isLoading = false;
          this.isQuestion = false;
        }
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  private getSavedData(id) {
    this.service.getSheetAnswers(id).then((data) => {
      if (data.length > 0) {
        this.sheetAnswerData = data[0];
        this.answers = JSON.parse(data[0].operations);
        this.attempted = this.answers.filter((e) => e.answer === true).length;
        this.questionComponentKey++;
      } else {
        this.sheetAnswerData = [];
      }
    });
  }

  private saveWatched() {
    // this.saveElastic();

    var topicsWatched: McqAttempted = {
      mcqAttemptId: config.createGuid(),
      userId: this.auth.session.userId,
      topicId: this.topicId,
      operationOn: new Date(Date.now()),
      duration: this.attempted,
      percentage: Math.round((this.attempted * 100) / this.questions.length),
    };

    this.service.insertMcq(topicsWatched).catch((err) => {
      console.error(`Error: ${err.message}`);
    });
  }

  saveElastic() {
    var msc = "";
    for (var que of this.answers) {
      if (que.answer == true) {
        msc = que.questionId + "=" + que.answer + ":";
        this.elasticSearchMCQs(msc);
      }
    }
  }

  elasticSearchMCQs(mcqs: string) {
    Vue.axios
      .post(
        "https://search.pgc.edu.pk/mcqs/wedgets/" +
          this.auth.session.userId +
          "!" +
          mcqs.split("=")[0],
        {
          body: { leftside: "mcqs", rightside: mcqs },
        }
      )
      .then((response) => {});
  }

  resetMCQ() {
    this.attempted = 0;
    this.answers = this.emptyAnswers;
    this.shouldDisplay = false;
    this.questionComponentKey++;
  }

  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "index",
        // A column that needs custom formatting
        { key: "fullName", label: "Chapter Name" },
      ],
      filter: null,
    };
  }

  created() {
    // window.addEventListener("beforeunload", this.handler);
    if (this.$route.query.type && this.$route.query.type == "pastpaper") {
      this.isPastPaper = true;
    }

    this.level_id = localStorage[config.classLevl];
    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }

    if (
      this.$store.state.selectSubject == "" ||
      this.$store.state.selectSubject == undefined ||
      this.$store.state.selectSubject == "null"
    ) {
      router.push("mcqsubject?type=customexam");
    }

    const programSelectString = localStorage[config.programSelect];
    const programSelectData = JSON.parse(programSelectString);
    const boardId = programSelectData.board.endsWith('s')
      ? programSelectData.board.slice(0, -1)
      : programSelectData.board;
    const classId = programSelectData.part.replace(/\s+/g, '');
    let programnaem: any;
    if (this.auth.session.varification == '-1' || this.auth.session.varification == '0' || this.auth.session.varification == '1') {
      programnaem = programSelectData.name;
    } else {
      programnaem = this.auth.session.varification;
    }

    const val = boardId + '?' + classId + '?HADAF?MCQs?' + this.isPastPaper +
      '?' + this.auth.session.userId + '?' + this.$store.state.selectSubject +
      '?' + this.$store.state.selectSubjectName;

    this.service
      .mcqArvoChapters(val, programnaem)
      .then((result) => {
        this.items = result;
        if (this.items.length > 0) {
          this.items.forEach(value => {
            value.fullName = value.fullName.replace(/^\d+[.)]\s*/, '');
          });
          if (this.items.findIndex((e) => e.fullName == 'Promo') > -1) {
            this.items.splice(this.items.findIndex((e) => e.fullName == 'Promo'), 1);
          }
          this.checkedChapters = [];
          this.allChapters = [];
          for (let i = 0; i < this.items.length; i++) {
            this.checkedChapters.push('not_checked');
            this.allChapters.push(this.items[i]);
          }
        }
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  // beforeDestroy() {
  //   window.removeEventListener("beforeunload", this.handler);
  //   this.saveWatched();
  // }

  // async handler(event) {
  //   event.preventDefault();
  //   try {
  //     // API call here
  //     await this.saveWatched();
  //     return ""; // Prompt with default browser message
  //   } catch (err) {
  //     return undefined; // Skip prompt
  //   }
  // }
}

interface ProvidedAnswers {
  questionId: string;
  answer: boolean;
  answerId: string;
}
